import Principal from '../../spa/principal/Principal';

export default {
    path: 'principal',
    name: 'principal',
    component: Principal,
};


// WEBPACK FOOTER //
// ./src/config/router/principal.js